/**
 * @generated SignedSource<<abca727ef012430d213bad1c927864eb>>
 * @relayHash 1f60c98c6fccfe82d54a9afafa9e67ab
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID db244e65feb072c61250c4600df018d46b524e3d2af71f65a296428262e4dabc

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type TownsquareUpdateStateFilter = "ACTIVE" | "AT_RISK" | "CANCELLED" | "DONE" | "NO_UPDATE" | "OFF_TRACK" | "ON_TRACK" | "PAUSED" | "PENDING" | "%future added value";
export type ReadingModeFullScreenQuery$variables = {
  containerId: string;
  createdAfter?: AGG$DateTime | null;
  createdBefore?: AGG$DateTime | null;
  isGoalUpdates: boolean;
  isProjectUpdates: boolean;
  isTagUpdates: boolean;
  isTeamUpdates: boolean;
  stateFilter?: TownsquareUpdateStateFilter | null;
  tagId: string;
  teamId: string;
};
export type ReadingModeFullScreenQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"GoalReadingModeInternals_GoalPagination" | "ProjectReadingModeInternals_ProjectPagination" | "TagReadingModeInternals_TagPagination" | "TeamReadingModeInternals_TeamPagination">;
};
export type ReadingModeFullScreenQuery = {
  response: ReadingModeFullScreenQuery$data;
  variables: ReadingModeFullScreenQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "containerId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "createdAfter"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "createdBefore"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isGoalUpdates"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isProjectUpdates"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isTagUpdates"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isTeamUpdates"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "stateFilter"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "tagId"
},
v9 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "teamId"
},
v10 = {
  "kind": "Variable",
  "name": "containerId",
  "variableName": "containerId"
},
v11 = {
  "kind": "Variable",
  "name": "createdAfter",
  "variableName": "createdAfter"
},
v12 = {
  "kind": "Variable",
  "name": "createdBefore",
  "variableName": "createdBefore"
},
v13 = {
  "kind": "Literal",
  "name": "first",
  "value": 15
},
v14 = {
  "kind": "Variable",
  "name": "stateFilter",
  "variableName": "stateFilter"
},
v15 = [
  (v10/*: any*/),
  (v11/*: any*/),
  (v12/*: any*/),
  (v13/*: any*/),
  (v14/*: any*/)
],
v16 = [
  (v10/*: any*/),
  (v11/*: any*/),
  (v13/*: any*/),
  {
    "kind": "Variable",
    "name": "teamId",
    "variableName": "teamId"
  }
],
v17 = [
  (v10/*: any*/),
  (v11/*: any*/),
  (v13/*: any*/),
  {
    "kind": "Variable",
    "name": "tagId",
    "variableName": "tagId"
  }
],
v18 = [
  (v10/*: any*/),
  (v11/*: any*/),
  (v12/*: any*/),
  (v14/*: any*/)
],
v19 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v20 = {
  "kind": "TypeDiscriminator",
  "abstractKey": "__isTownsquareUpdate"
},
v21 = {
  "kind": "ScalarField",
  "name": "id"
},
v22 = {
  "kind": "ScalarField",
  "name": "uuid"
},
v23 = {
  "kind": "ScalarField",
  "name": "canCommentOnUpdates"
},
v24 = {
  "kind": "ScalarField",
  "name": "canEditUpdates"
},
v25 = {
  "kind": "ScalarField",
  "name": "key"
},
v26 = {
  "kind": "ScalarField",
  "name": "name"
},
v27 = {
  "kind": "ScalarField",
  "name": "isArchived"
},
v28 = {
  "kind": "ScalarField",
  "name": "summary"
},
v29 = {
  "kind": "ScalarField",
  "name": "description"
},
v30 = [
  (v21/*: any*/),
  (v28/*: any*/),
  {
    "concreteType": "TownsquareUpdateNoteConnection",
    "kind": "LinkedField",
    "name": "updateNotes",
    "plural": false,
    "selections": [
      {
        "concreteType": "TownsquareUpdateNoteEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "concreteType": "TownsquareUpdateNote",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              (v28/*: any*/),
              (v29/*: any*/),
              (v21/*: any*/)
            ]
          }
        ]
      }
    ]
  }
],
v31 = {
  "kind": "ScalarField",
  "name": "url"
},
v32 = {
  "concreteType": "TownsquareUpdateGenerationSettings",
  "kind": "LinkedField",
  "name": "updateGenerationSettings",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "templateKey"
    }
  ]
},
v33 = {
  "kind": "ScalarField",
  "name": "canCreateUpdates"
},
v34 = {
  "kind": "ScalarField",
  "name": "ari"
},
v35 = {
  "kind": "ScalarField",
  "name": "missedUpdate"
},
v36 = {
  "kind": "ScalarField",
  "name": "updateType"
},
v37 = {
  "kind": "ScalarField",
  "name": "picture"
},
v38 = {
  "kind": "ScalarField",
  "name": "accountId"
},
v39 = {
  "kind": "ScalarField",
  "name": "start"
},
v40 = {
  "kind": "ScalarField",
  "name": "end"
},
v41 = [
  {
    "kind": "ScalarField",
    "name": "label"
  },
  {
    "concreteType": "TownsquareTargetDateRange",
    "kind": "LinkedField",
    "name": "dateRange",
    "plural": false,
    "selections": [
      (v39/*: any*/),
      (v40/*: any*/)
    ]
  }
],
v42 = {
  "concreteType": "TownsquareTargetDate",
  "kind": "LinkedField",
  "name": "newDueDate",
  "plural": false,
  "selections": (v41/*: any*/)
},
v43 = [
  {
    "alias": "projectValue",
    "kind": "ScalarField",
    "name": "value"
  }
],
v44 = {
  "kind": "LinkedField",
  "name": "lastEditedBy",
  "plural": false,
  "selections": [
    (v19/*: any*/),
    (v38/*: any*/),
    (v26/*: any*/),
    (v21/*: any*/)
  ]
},
v45 = {
  "kind": "ScalarField",
  "name": "creationDate"
},
v46 = {
  "kind": "ScalarField",
  "name": "editDate"
},
v47 = [
  (v21/*: any*/)
],
v48 = [
  {
    "kind": "LinkedField",
    "name": "node",
    "plural": false,
    "selections": [
      (v19/*: any*/),
      {
        "kind": "InlineFragment",
        "selections": [
          (v21/*: any*/),
          (v26/*: any*/),
          (v38/*: any*/),
          (v37/*: any*/)
        ],
        "type": "AtlassianAccountUser"
      },
      {
        "kind": "InlineFragment",
        "selections": (v47/*: any*/),
        "type": "AppUser"
      },
      {
        "kind": "InlineFragment",
        "selections": (v47/*: any*/),
        "type": "CustomerUser"
      }
    ]
  },
  (v21/*: any*/)
],
v49 = {
  "concreteType": "TownsquareTargetDate",
  "kind": "LinkedField",
  "name": "oldDueDate",
  "plural": false,
  "selections": (v41/*: any*/)
},
v50 = {
  "kind": "ScalarField",
  "name": "newTargetDate"
},
v51 = {
  "kind": "ScalarField",
  "name": "newTargetDateConfidence"
},
v52 = {
  "kind": "ScalarField",
  "name": "archived"
},
v53 = {
  "concreteType": "TownsquareUpdateNoteConnection",
  "kind": "LinkedField",
  "name": "updateNotes",
  "plural": false,
  "selections": [
    {
      "concreteType": "TownsquareUpdateNoteEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "concreteType": "TownsquareUpdateNote",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v21/*: any*/),
            (v28/*: any*/),
            (v29/*: any*/),
            (v52/*: any*/)
          ]
        }
      ]
    }
  ]
},
v54 = [
  (v19/*: any*/),
  (v37/*: any*/),
  (v26/*: any*/),
  (v38/*: any*/),
  (v21/*: any*/)
],
v55 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__id"
    }
  ]
},
v56 = {
  "concreteType": "TownsquareHighlightConnection",
  "kind": "LinkedField",
  "name": "highlights",
  "plural": false,
  "selections": [
    {
      "concreteType": "TownsquareHighlightEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v28/*: any*/),
            (v29/*: any*/),
            (v19/*: any*/),
            (v21/*: any*/),
            {
              "kind": "TypeDiscriminator",
              "abstractKey": "__isTownsquareHighlight"
            },
            {
              "kind": "LinkedField",
              "name": "creator",
              "plural": false,
              "selections": (v54/*: any*/)
            },
            {
              "kind": "LinkedField",
              "name": "lastEditedBy",
              "plural": false,
              "selections": (v54/*: any*/)
            },
            (v45/*: any*/),
            {
              "kind": "ScalarField",
              "name": "lastEditedDate"
            }
          ]
        }
      ]
    },
    (v55/*: any*/)
  ]
},
v57 = {
  "concreteType": "TownsquareCommentConnection",
  "kind": "LinkedField",
  "name": "comments",
  "plural": false,
  "selections": [
    {
      "concreteType": "TownsquareCommentEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "concreteType": "TownsquareComment",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v21/*: any*/),
            {
              "kind": "LinkedField",
              "name": "creator",
              "plural": false,
              "selections": [
                (v19/*: any*/),
                (v26/*: any*/),
                (v21/*: any*/),
                (v38/*: any*/),
                (v37/*: any*/)
              ]
            },
            {
              "kind": "ScalarField",
              "name": "commentText"
            },
            (v46/*: any*/),
            (v45/*: any*/)
          ]
        }
      ]
    },
    (v55/*: any*/)
  ]
},
v58 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "TownsquareProject",
      "kind": "LinkedField",
      "name": "project",
      "plural": false,
      "selections": [
        (v21/*: any*/),
        {
          "kind": "ScalarField",
          "name": "watching"
        },
        (v22/*: any*/),
        {
          "concreteType": "TownsquareProjectCapabilities",
          "kind": "LinkedField",
          "name": "capabilities",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "canWatchProject"
            },
            (v23/*: any*/),
            (v24/*: any*/)
          ]
        },
        {
          "kind": "ScalarField",
          "name": "isPrivate"
        },
        {
          "concreteType": "TownsquareIconURIs",
          "kind": "LinkedField",
          "name": "iconUrl",
          "plural": false,
          "selections": [
            {
              "concreteType": "TownsquareThemeURIs",
              "kind": "LinkedField",
              "name": "square",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "light"
                },
                {
                  "kind": "ScalarField",
                  "name": "dark"
                },
                {
                  "kind": "ScalarField",
                  "name": "transparent"
                }
              ]
            }
          ]
        },
        (v25/*: any*/),
        (v26/*: any*/),
        (v27/*: any*/),
        {
          "kind": "ScalarField",
          "name": "startDate"
        },
        {
          "concreteType": "TownsquareProjectUpdate",
          "kind": "LinkedField",
          "name": "latestUserUpdate",
          "plural": false,
          "selections": (v30/*: any*/)
        },
        (v31/*: any*/),
        (v32/*: any*/),
        {
          "concreteType": "TownsquareProjectCapabilities",
          "kind": "LinkedField",
          "name": "capabilities",
          "plural": false,
          "selections": [
            (v33/*: any*/)
          ]
        }
      ]
    },
    (v21/*: any*/),
    (v34/*: any*/),
    (v35/*: any*/),
    (v36/*: any*/),
    (v28/*: any*/),
    {
      "kind": "LinkedField",
      "name": "creator",
      "plural": false,
      "selections": [
        (v19/*: any*/),
        (v26/*: any*/),
        (v37/*: any*/),
        (v21/*: any*/),
        (v38/*: any*/)
      ]
    },
    (v42/*: any*/),
    {
      "concreteType": "TownsquareProjectState",
      "kind": "LinkedField",
      "name": "newState",
      "plural": false,
      "selections": (v43/*: any*/)
    },
    (v44/*: any*/),
    (v45/*: any*/),
    (v46/*: any*/),
    (v31/*: any*/),
    {
      "concreteType": "GraphStoreSimplifiedUserViewedProjectUpdateInverseConnection",
      "kind": "LinkedField",
      "name": "viewers",
      "plural": false,
      "selections": [
        {
          "concreteType": "GraphStoreSimplifiedUserViewedProjectUpdateInverseEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": (v48/*: any*/)
        }
      ]
    },
    {
      "concreteType": "TownsquareProjectState",
      "kind": "LinkedField",
      "name": "oldState",
      "plural": false,
      "selections": (v43/*: any*/)
    },
    (v49/*: any*/),
    (v50/*: any*/),
    (v51/*: any*/),
    (v53/*: any*/),
    (v56/*: any*/),
    (v57/*: any*/)
  ],
  "type": "TownsquareProjectUpdate"
},
v59 = {
  "kind": "ScalarField",
  "name": "type"
},
v60 = {
  "kind": "ScalarField",
  "name": "subType"
},
v61 = {
  "kind": "ScalarField",
  "name": "source"
},
v62 = {
  "kind": "ScalarField",
  "name": "time"
},
v63 = {
  "concreteType": "TownsquareMetricValue",
  "kind": "LinkedField",
  "name": "latestValue",
  "plural": false,
  "selections": [
    (v62/*: any*/),
    (v21/*: any*/)
  ]
},
v64 = {
  "kind": "ScalarField",
  "name": "value"
},
v65 = {
  "kind": "ScalarField",
  "name": "percentage"
},
v66 = [
  {
    "kind": "ScalarField",
    "name": "count"
  }
],
v67 = [
  (v64/*: any*/)
],
v68 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "messageId"
    },
    {
      "kind": "ScalarField",
      "name": "defaultValue"
    }
  ],
  "type": "TownsquareLocalizationField"
},
v69 = {
  "kind": "ScalarField",
  "name": "score"
},
v70 = [
  (v64/*: any*/),
  (v69/*: any*/)
],
v71 = [
  (v64/*: any*/),
  (v69/*: any*/),
  {
    "concreteType": "TownsquareCompletionGoalState",
    "kind": "LinkedField",
    "name": "atCompletionState",
    "plural": false,
    "selections": (v70/*: any*/)
  }
],
v72 = {
  "kind": "Literal",
  "name": "first",
  "value": 100
},
v73 = {
  "kind": "InlineFragment",
  "selections": [
    (v21/*: any*/),
    {
      "concreteType": "TownsquareGoal",
      "kind": "LinkedField",
      "name": "goal",
      "plural": false,
      "selections": [
        (v21/*: any*/),
        {
          "kind": "ScalarField",
          "name": "isWatching"
        },
        (v22/*: any*/),
        {
          "concreteType": "TownsquareGoalCapabilities",
          "kind": "LinkedField",
          "name": "capabilities",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "canWatchGoal"
            },
            (v23/*: any*/),
            (v33/*: any*/),
            (v24/*: any*/),
            {
              "kind": "ScalarField",
              "name": "canDeleteUpdates"
            }
          ]
        },
        (v25/*: any*/),
        (v26/*: any*/),
        {
          "concreteType": "TownsquareGoal",
          "kind": "LinkedField",
          "name": "parentGoal",
          "plural": false,
          "selections": (v47/*: any*/)
        },
        {
          "concreteType": "TownsquareGoalIcon",
          "kind": "LinkedField",
          "name": "icon",
          "plural": false,
          "selections": [
            (v25/*: any*/),
            {
              "kind": "ScalarField",
              "name": "appearance"
            }
          ]
        },
        {
          "concreteType": "TownsquareMetricTargetConnection",
          "kind": "LinkedField",
          "name": "metricTargets",
          "plural": false,
          "selections": [
            {
              "concreteType": "TownsquareMetricTargetEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "concreteType": "TownsquareMetricTarget",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "concreteType": "TownsquareMetric",
                      "kind": "LinkedField",
                      "name": "metric",
                      "plural": false,
                      "selections": [
                        (v21/*: any*/),
                        (v52/*: any*/),
                        (v26/*: any*/),
                        (v59/*: any*/),
                        (v60/*: any*/),
                        {
                          "kind": "ScalarField",
                          "name": "externalEntityId"
                        },
                        (v61/*: any*/),
                        (v63/*: any*/)
                      ]
                    },
                    {
                      "concreteType": "TownsquareMetricTargetPeriodConnection",
                      "kind": "LinkedField",
                      "name": "metricTargetPeriods",
                      "plural": false,
                      "selections": [
                        {
                          "concreteType": "TownsquareMetricTargetPeriodEdge",
                          "kind": "LinkedField",
                          "name": "edges",
                          "plural": true,
                          "selections": [
                            {
                              "concreteType": "TownsquareMetricTargetPeriod",
                              "kind": "LinkedField",
                              "name": "node",
                              "plural": false,
                              "selections": [
                                {
                                  "concreteType": "TownsquareTargetDate",
                                  "kind": "LinkedField",
                                  "name": "date",
                                  "plural": false,
                                  "selections": [
                                    {
                                      "concreteType": "TownsquareTargetDateRange",
                                      "kind": "LinkedField",
                                      "name": "dateRange",
                                      "plural": false,
                                      "selections": [
                                        (v39/*: any*/)
                                      ]
                                    }
                                  ]
                                },
                                (v64/*: any*/)
                              ]
                            }
                          ]
                        }
                      ]
                    },
                    (v21/*: any*/),
                    {
                      "kind": "ScalarField",
                      "name": "startValue"
                    },
                    {
                      "kind": "ScalarField",
                      "name": "targetValue"
                    },
                    {
                      "concreteType": "TownsquareMetricValue",
                      "kind": "LinkedField",
                      "name": "snapshotValue",
                      "plural": false,
                      "selections": [
                        (v64/*: any*/),
                        (v21/*: any*/)
                      ]
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          "kind": "ScalarField",
          "name": "scoringMode"
        },
        {
          "args": [
            {
              "kind": "Literal",
              "name": "first",
              "value": 10
            }
          ],
          "concreteType": "TownsquareGoalUpdateConnection",
          "kind": "LinkedField",
          "name": "updates",
          "plural": false,
          "selections": [
            {
              "concreteType": "TownsquareGoalUpdateEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "concreteType": "TownsquareGoalUpdate",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": (v30/*: any*/)
                }
              ]
            }
          ],
          "storageKey": "updates(first:10)"
        },
        (v32/*: any*/),
        {
          "concreteType": "TownsquareGoalProgress",
          "kind": "LinkedField",
          "name": "progress",
          "plural": false,
          "selections": [
            (v65/*: any*/),
            (v59/*: any*/)
          ]
        },
        {
          "concreteType": "TownsquareGoalConnection",
          "kind": "LinkedField",
          "name": "subGoals",
          "plural": false,
          "selections": (v66/*: any*/)
        },
        {
          "alias": "successMeasureCount",
          "concreteType": "TownsquareGoalConnection",
          "kind": "LinkedField",
          "name": "successMeasures",
          "plural": false,
          "selections": (v66/*: any*/)
        },
        {
          "concreteType": "TownsquareGoalType",
          "kind": "LinkedField",
          "name": "goalType",
          "plural": false,
          "selections": [
            {
              "concreteType": "TownsquareGoalType",
              "kind": "LinkedField",
              "name": "successMeasure",
              "plural": false,
              "selections": [
                {
                  "kind": "LinkedField",
                  "name": "name",
                  "plural": false,
                  "selections": [
                    (v19/*: any*/),
                    {
                      "kind": "InlineFragment",
                      "selections": (v67/*: any*/),
                      "type": "TownsquareGoalTypeCustomName"
                    },
                    (v68/*: any*/)
                  ]
                },
                {
                  "kind": "LinkedField",
                  "name": "namePlural",
                  "plural": false,
                  "selections": [
                    (v19/*: any*/),
                    {
                      "kind": "InlineFragment",
                      "selections": (v67/*: any*/),
                      "type": "TownsquareGoalTypeCustomNamePlural"
                    },
                    (v68/*: any*/)
                  ]
                },
                (v21/*: any*/)
              ]
            },
            (v21/*: any*/)
          ]
        },
        {
          "concreteType": "TownsquareTargetDate",
          "kind": "LinkedField",
          "name": "targetDate",
          "plural": false,
          "selections": [
            {
              "concreteType": "TownsquareTargetDateRange",
              "kind": "LinkedField",
              "name": "dateRange",
              "plural": false,
              "selections": [
                (v40/*: any*/)
              ]
            }
          ]
        },
        {
          "kind": "ScalarField",
          "name": "canPostUpdate"
        },
        (v27/*: any*/),
        {
          "kind": "ScalarField",
          "name": "canEditUpdate"
        }
      ]
    },
    (v34/*: any*/),
    (v35/*: any*/),
    (v36/*: any*/),
    {
      "kind": "ScalarField",
      "name": "hasConnectedUpdates"
    },
    (v28/*: any*/),
    {
      "concreteType": "TownsquareGoalState",
      "kind": "LinkedField",
      "name": "newState",
      "plural": false,
      "selections": (v71/*: any*/)
    },
    (v50/*: any*/),
    (v51/*: any*/),
    (v53/*: any*/),
    (v56/*: any*/),
    (v45/*: any*/),
    {
      "concreteType": "TownsquareGoalMetricUpdateConnection",
      "kind": "LinkedField",
      "name": "metricUpdate",
      "plural": false,
      "selections": [
        {
          "concreteType": "TownsquareGoalMetricUpdateEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "concreteType": "TownsquareGoalMetricUpdate",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "concreteType": "TownsquareMetric",
                  "kind": "LinkedField",
                  "name": "metric",
                  "plural": false,
                  "selections": [
                    (v21/*: any*/),
                    (v26/*: any*/),
                    (v59/*: any*/),
                    (v60/*: any*/),
                    (v52/*: any*/),
                    (v61/*: any*/),
                    (v63/*: any*/),
                    {
                      "args": [
                        (v72/*: any*/),
                        {
                          "kind": "Literal",
                          "name": "sort",
                          "value": [
                            "TIME_DESC"
                          ]
                        }
                      ],
                      "concreteType": "TownsquareMetricValueConnection",
                      "kind": "LinkedField",
                      "name": "values",
                      "plural": false,
                      "selections": [
                        {
                          "concreteType": "TownsquareMetricValueEdge",
                          "kind": "LinkedField",
                          "name": "edges",
                          "plural": true,
                          "selections": [
                            {
                              "concreteType": "TownsquareMetricValue",
                              "kind": "LinkedField",
                              "name": "node",
                              "plural": false,
                              "selections": [
                                (v21/*: any*/),
                                (v64/*: any*/),
                                (v62/*: any*/),
                                {
                                  "kind": "LinkedField",
                                  "name": "creator",
                                  "plural": false,
                                  "selections": [
                                    (v19/*: any*/),
                                    (v26/*: any*/),
                                    (v37/*: any*/),
                                    (v21/*: any*/)
                                  ]
                                },
                                {
                                  "kind": "LinkedField",
                                  "name": "origin",
                                  "plural": false,
                                  "selections": [
                                    (v19/*: any*/),
                                    {
                                      "kind": "InlineFragment",
                                      "selections": [
                                        {
                                          "concreteType": "TownsquareGoalUpdate",
                                          "kind": "LinkedField",
                                          "name": "goalUpdate",
                                          "plural": false,
                                          "selections": [
                                            (v45/*: any*/),
                                            {
                                              "concreteType": "TownsquareGoal",
                                              "kind": "LinkedField",
                                              "name": "goal",
                                              "plural": false,
                                              "selections": (v47/*: any*/)
                                            },
                                            {
                                              "concreteType": "TownsquareGoalState",
                                              "kind": "LinkedField",
                                              "name": "newState",
                                              "plural": false,
                                              "selections": (v70/*: any*/)
                                            },
                                            (v21/*: any*/)
                                          ]
                                        }
                                      ],
                                      "type": "TownsquareFromGoalUpdate"
                                    },
                                    {
                                      "kind": "InlineFragment",
                                      "selections": [
                                        (v45/*: any*/)
                                      ],
                                      "type": "TownsquareFromMetricCreation"
                                    },
                                    {
                                      "kind": "InlineFragment",
                                      "selections": [
                                        {
                                          "kind": "ScalarField",
                                          "name": "updateDate"
                                        }
                                      ],
                                      "type": "TownsquareFromMetricUpdate"
                                    }
                                  ]
                                }
                              ]
                            }
                          ]
                        }
                      ],
                      "storageKey": "values(first:100,sort:[\"TIME_DESC\"])"
                    }
                  ]
                },
                {
                  "concreteType": "TownsquareMetricValue",
                  "kind": "LinkedField",
                  "name": "newValue",
                  "plural": false,
                  "selections": [
                    (v64/*: any*/),
                    (v62/*: any*/),
                    (v21/*: any*/)
                  ]
                },
                {
                  "concreteType": "TownsquareMetricValue",
                  "kind": "LinkedField",
                  "name": "oldValue",
                  "plural": false,
                  "selections": [
                    (v62/*: any*/),
                    (v21/*: any*/),
                    (v64/*: any*/)
                  ]
                },
                {
                  "kind": "ScalarField",
                  "name": "newStartValue"
                },
                {
                  "kind": "ScalarField",
                  "name": "newTargetValue"
                }
              ]
            }
          ]
        }
      ]
    },
    {
      "kind": "LinkedField",
      "name": "creator",
      "plural": false,
      "selections": [
        (v19/*: any*/),
        (v38/*: any*/),
        (v26/*: any*/),
        (v37/*: any*/),
        (v21/*: any*/)
      ]
    },
    (v42/*: any*/),
    {
      "concreteType": "TownsquareGoalProgress",
      "kind": "LinkedField",
      "name": "newProgress",
      "plural": false,
      "selections": [
        (v59/*: any*/),
        (v65/*: any*/)
      ]
    },
    {
      "args": [
        {
          "kind": "Literal",
          "name": "first",
          "value": 50
        }
      ],
      "concreteType": "TownsquareGoalBundledUpdateConnection",
      "kind": "LinkedField",
      "name": "bundledUpdates",
      "plural": false,
      "selections": [
        {
          "concreteType": "TownsquareGoalBundledUpdateEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "concreteType": "TownsquareGoal",
              "kind": "LinkedField",
              "name": "successMeasure",
              "plural": false,
              "selections": [
                {
                  "concreteType": "TownsquareGoalProgress",
                  "kind": "LinkedField",
                  "name": "progress",
                  "plural": false,
                  "selections": [
                    (v65/*: any*/)
                  ]
                },
                (v21/*: any*/)
              ]
            }
          ]
        }
      ],
      "storageKey": "bundledUpdates(first:50)"
    },
    (v44/*: any*/),
    (v46/*: any*/),
    (v31/*: any*/),
    {
      "args": [
        (v72/*: any*/)
      ],
      "concreteType": "GraphStoreSimplifiedUserViewedGoalUpdateInverseConnection",
      "kind": "LinkedField",
      "name": "viewers",
      "plural": false,
      "selections": [
        {
          "concreteType": "GraphStoreSimplifiedUserViewedGoalUpdateInverseEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": (v48/*: any*/)
        }
      ],
      "storageKey": "viewers(first:100)"
    },
    (v57/*: any*/),
    {
      "concreteType": "TownsquareGoalState",
      "kind": "LinkedField",
      "name": "oldState",
      "plural": false,
      "selections": (v71/*: any*/)
    },
    (v49/*: any*/)
  ],
  "type": "TownsquareGoalUpdate"
},
v74 = [
  (v21/*: any*/),
  (v26/*: any*/)
],
v75 = {
  "kind": "InlineFragment",
  "selections": [
    (v21/*: any*/),
    {
      "concreteType": "TownsquareProject",
      "kind": "LinkedField",
      "name": "project",
      "plural": false,
      "selections": (v74/*: any*/)
    },
    {
      "alias": "newProjectState",
      "concreteType": "TownsquareProjectState",
      "kind": "LinkedField",
      "name": "newState",
      "plural": false,
      "selections": (v67/*: any*/)
    },
    (v35/*: any*/),
    (v36/*: any*/)
  ],
  "type": "TownsquareProjectUpdate"
},
v76 = {
  "kind": "InlineFragment",
  "selections": (v47/*: any*/),
  "type": "Node",
  "abstractKey": "__isNode"
},
v77 = {
  "kind": "ScalarField",
  "name": "cursor"
},
v78 = {
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "endCursor"
    },
    {
      "kind": "ScalarField",
      "name": "hasNextPage"
    }
  ]
},
v79 = [
  "createdBefore",
  "createdAfter",
  "containerId",
  "stateFilter"
],
v80 = {
  "kind": "InlineFragment",
  "selections": [
    (v21/*: any*/),
    {
      "concreteType": "TownsquareGoal",
      "kind": "LinkedField",
      "name": "goal",
      "plural": false,
      "selections": (v74/*: any*/)
    },
    {
      "alias": "newGoalState",
      "concreteType": "TownsquareGoalState",
      "kind": "LinkedField",
      "name": "newState",
      "plural": false,
      "selections": (v67/*: any*/)
    },
    (v35/*: any*/),
    (v36/*: any*/)
  ],
  "type": "TownsquareGoalUpdate"
},
v81 = [
  {
    "concreteType": "TownsquareUpdateEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      (v19/*: any*/),
      {
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v20/*: any*/),
          (v19/*: any*/),
          (v58/*: any*/),
          (v73/*: any*/),
          (v75/*: any*/),
          (v80/*: any*/),
          (v76/*: any*/)
        ]
      },
      (v77/*: any*/)
    ]
  },
  (v78/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/)
    ],
    "kind": "Fragment",
    "name": "ReadingModeFullScreenQuery",
    "selections": [
      {
        "condition": "isProjectUpdates",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": (v15/*: any*/),
            "kind": "FragmentSpread",
            "name": "ProjectReadingModeInternals_ProjectPagination"
          }
        ]
      },
      {
        "condition": "isGoalUpdates",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": (v15/*: any*/),
            "kind": "FragmentSpread",
            "name": "GoalReadingModeInternals_GoalPagination"
          }
        ]
      },
      {
        "condition": "isTeamUpdates",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": (v16/*: any*/),
            "kind": "FragmentSpread",
            "name": "TeamReadingModeInternals_TeamPagination"
          }
        ]
      },
      {
        "condition": "isTagUpdates",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": (v17/*: any*/),
            "kind": "FragmentSpread",
            "name": "TagReadingModeInternals_TagPagination"
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v4/*: any*/),
      (v3/*: any*/),
      (v6/*: any*/),
      (v5/*: any*/),
      (v0/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/),
      (v7/*: any*/),
      (v9/*: any*/),
      (v8/*: any*/)
    ],
    "kind": "Operation",
    "name": "ReadingModeFullScreenQuery",
    "selections": [
      {
        "condition": "isProjectUpdates",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": (v18/*: any*/),
            "kind": "ScalarField",
            "name": "projects_allWatchedProjectUpdatesCount"
          },
          {
            "args": (v15/*: any*/),
            "concreteType": "TownsquareUpdateConnection",
            "kind": "LinkedField",
            "name": "projects_allWatchedProjectUpdates",
            "plural": false,
            "selections": [
              {
                "concreteType": "TownsquareUpdateEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v19/*: any*/),
                      (v20/*: any*/),
                      (v58/*: any*/),
                      (v73/*: any*/),
                      (v75/*: any*/),
                      (v76/*: any*/)
                    ]
                  },
                  (v77/*: any*/)
                ]
              },
              (v78/*: any*/)
            ]
          },
          {
            "args": (v15/*: any*/),
            "filters": (v79/*: any*/),
            "handle": "connection",
            "key": "ProjectReadingModeInternals__projects_allWatchedProjectUpdates",
            "kind": "LinkedHandle",
            "name": "projects_allWatchedProjectUpdates"
          }
        ]
      },
      {
        "condition": "isGoalUpdates",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": (v18/*: any*/),
            "kind": "ScalarField",
            "name": "goals_allWatchedGoalUpdatesCount"
          },
          {
            "args": (v15/*: any*/),
            "concreteType": "TownsquareUpdateConnection",
            "kind": "LinkedField",
            "name": "goals_allWatchedGoalUpdates",
            "plural": false,
            "selections": [
              {
                "concreteType": "TownsquareUpdateEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v19/*: any*/),
                      (v20/*: any*/),
                      (v58/*: any*/),
                      (v73/*: any*/),
                      (v80/*: any*/),
                      (v76/*: any*/)
                    ]
                  },
                  (v77/*: any*/)
                ]
              },
              (v78/*: any*/)
            ]
          },
          {
            "args": (v15/*: any*/),
            "filters": (v79/*: any*/),
            "handle": "connection",
            "key": "GoalReadingModeInternals__goals_allWatchedGoalUpdates",
            "kind": "LinkedHandle",
            "name": "goals_allWatchedGoalUpdates"
          }
        ]
      },
      {
        "condition": "isTeamUpdates",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": (v16/*: any*/),
            "concreteType": "TownsquareUpdateConnection",
            "kind": "LinkedField",
            "name": "statusUpdates_byTeam",
            "plural": false,
            "selections": (v81/*: any*/)
          },
          {
            "args": (v16/*: any*/),
            "filters": [
              "teamId",
              "containerId",
              "createdAfter"
            ],
            "handle": "connection",
            "key": "TeamReadingModeInternals__statusUpdates_byTeam",
            "kind": "LinkedHandle",
            "name": "statusUpdates_byTeam"
          }
        ]
      },
      {
        "condition": "isTagUpdates",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": (v17/*: any*/),
            "concreteType": "TownsquareUpdateConnection",
            "kind": "LinkedField",
            "name": "statusUpdates_byTag",
            "plural": false,
            "selections": (v81/*: any*/)
          },
          {
            "args": (v17/*: any*/),
            "filters": [
              "tagId",
              "createdAfter",
              "containerId"
            ],
            "handle": "connection",
            "key": "TagReadingModeInternals__statusUpdates_byTag",
            "kind": "LinkedHandle",
            "name": "statusUpdates_byTag"
          }
        ]
      }
    ]
  },
  "params": {
    "id": "db244e65feb072c61250c4600df018d46b524e3d2af71f65a296428262e4dabc",
    "metadata": {},
    "name": "ReadingModeFullScreenQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "e2d45e98b304835fd36cae9879065ed1";

export default node;
